export default __webpack_public_path__ + "static/SSSpyView_screenshot-4-920297964a3431ebc7ecd6a4ee908074.webp";